import { axiosInterceptor } from "./axios.interceptor";
import { loadConfig } from "utils/config";

export const apiGetServices = async (id) => {
  const config = await loadConfig();
  return axiosInterceptor.get(`${config.AUTHEN_API}/services/${id}`);
  };